<template>
  <div>
    <v-autocomplete
      :value="tax"
      :items="filterTaxes"
      :label="hideLabel || hideLabel === '' ? '' : $i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
      :class="class1"
      :disabled="disabled"
      :dense="dense"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32" v-if="data && data.item">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title v-if="data && data.item">
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="taxClientDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Tax Slab") }}
          </v-btn>
        </div>
        <div class="actionBox" v-if="showInvoiceConfig">
          <v-btn small text color="info" @click="invoiceConfigDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Setup Tax Configuration") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-tax-create
      @select="selectTaxSlab"
      :showDialog="taxClientDialog"
    ></z-tax-create>
    <z-invoice-config-set
      v-if="showInvoiceConfig"
      @closeInvConfig="closeInvConfig"
      :showDialog="invoiceConfigDialog"
      :client_id="client_id"
    ></z-invoice-config-set>
  </div>
</template>

<script>
// import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TaxSelect",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: null,
    },
    label: {
      default: "Tax",
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
    client_id: {
      default: null,
    },
    showInvoiceConfig: {
      default: false,
    },
    item: {
      default: null,
    },
    class1: {
      default: null,
    },
    disabled: {
      default: false,
    },
    hideLabel: {
      default: false,
    },
    dense: {
      default: false,
    },
  },
})
export default class TaxSelect extends (Vue, Themeable) {
  tax = null;
  tax_id = null;
  taxes = [];
  filter = "";
  taxClientDialog = false;
  invoiceConfigDialog = false;
  loading = false;

  clear() {
    this.filter = "";
    this.tax = null;
    this.$emit("fullTax", null, this.item);
    this.$emit("input", null);
  }

  get filterTaxes() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.taxes;
    const fs = this.taxes.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  closeInvConfig() {
    this.invoiceConfigDialog = false;
  }

  selectTaxSlab(newTax) {
    this.taxClientDialog = false;
    if (newTax != null) {
      this.tax_id = newTax._id;
      this.init();
      // this.changedTo(newTax);
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.tax = newVal;
    }
    if (newVal && newVal.name) {
      this.$emit("fullTax", newVal, this.item);
      this.$emit("input", newVal._id);
    }
    if (!newVal) {
      this.$emit("fullTax", null, this.item);
      this.$emit("input", null);
    }
  }

  @Watch("value")
  async onValueChange(newVal) {
    this.tax_id = newVal;
    this.init();
  }

  async init() {
    // const url = `/api/taxslab/all?client_id=${val}`;
    // this.taxes = await doGet(url);
    this.filter = "";

    let localVal = "";
    if (this.corp) {
      localVal = this.corp;
    } else {
      localVal = "self";
    }
    await corpService.populateTaxes(localVal);
    const taxes = corpService.taxes[localVal];
    this.taxes = taxes;

    if (this.tax_id && this.taxes) {
      for (let i = 0; i < this.taxes.length; i++) {
        if (this.taxes[i]._id === this.tax_id) {
          this.tax = this.taxes[i];
          this.$emit("input", this.tax._id);
          this.$emit("fullTax", this.tax, this.item);
          break;
        }
      }
    }
  }

  async mounted() {
    await this.onValueChange(this.value);
    // await this.init(this.corp);
  }

  selected(val) {
    if (
      val != null &&
      val._id != null &&
      this.tax != null &&
      this.tax._id != undefined
    ) {
      if (val._id === this.tax._id) {
        return true;
      }
    }
    return false;
  }

  @Watch("corp", { immediate: true })
  async onCorpChange(val) {
    await this.init(val);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
